export const state = {
  files: [],
  systemFileopening: [],
  file_no: [],
  fileopenings: []
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/fileopenings/state.js